import { useClearRefinements } from 'react-instantsearch-hooks-web';
import { CurrentRefinements } from 'react-instantsearch-hooks-web';
import React, { useState, useEffect } from 'react';


export function CustomClearRefinements(props) {
  const { refine, canRefine, createURL } = useClearRefinements(props);
  // console.log('props before refine:', props);

  const [isDisabled, setDisabled] = useState(0);
  

  const checkURL = () => {
    // console.log('check url');
    let findQuery = window.location.href.indexOf("?");
    // console.log(window.location.href);
    // console.log('find q: ',findQuery);
    if (findQuery > -1) {
        //enable button - filters active
        // console.log('url has filters active');
        // let selem = document.querySelector('#searchreset');
        // selem.setAttribute('disabled', false);
        setDisabled(false);
    }
    else{
        //remove disabled
        // console.log('url has no active filters');
        // let selem = document.querySelector('#searchreset');
        // selem.setAttribute('disabled', true);
        setDisabled(true);
    }
  }

  const refineNow = ()=>{
    refine();
    // console.log('after refined:', window.location.href);
    checkURL();
  }
  useEffect(() => {    
    // Update the document title using the browser API    
    // console.log('checking...'); 
    setTimeout(() => {
      checkURL();
      
    }, 500);
}) ;

  return <>{
    <div className="clearContainer" >
        <button className="btn searchclearbutton" id="searchreset" onClick={refineNow} disabled={isDisabled}> 
            <span>
              Clear Filters
            </span>
        </button>
    </div>
    }</>;
}
